import React from "react";
import PropTypes from "prop-types";

function Radio({ filter, selected, handleChange }) {
  const radioOptions = filter && filter.get("options");

  if (!radioOptions || radioOptions.size < 1) {
    return null;
  }

  return (
    // eslint-disable-line
    <div>
      {radioOptions.map((radioOption, index) => (
        <label key={index}>
          <input
            type="radio"
            name={filter.get("filterTicker")}
            value={radioOption.get("pattern")}
            checked={selected === radioOption.get("optionTicker")}
            onChange={event =>
              handleChange(filter.get("type"), filter.get("filterTicker"), event.target.value)
            }
          />
          {radioOption.get("optionName")}
        </label>
      ))}
    </div>
  );
}

Radio.propTypes = {
  filter: PropTypes.array.object,
  selected: PropTypes.array.string,
  handleChange: PropTypes.array.function,
};

export default Radio;
